import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getPostsFromFirestore } from '../../firebase/postService';
import { getToolsFromFirestore } from '../../firebase/toolService';
import styles from './PostDetail.module.css';
import { useUserDisplayName } from '../../hooks/useUserDisplayName';
import useAuth from '../../hooks/useAuth';
import { deletePostFromFirestore } from '../../firebase/deletePostService';

const PostDetail = () => {
  const { id } = useParams();
  const { user } = useAuth();
  // 投稿削除処理
  const handleDelete = async () => {
    if (!window.confirm('本当にこの投稿を削除しますか？')) return;
    await deletePostFromFirestore(post.id);
    navigate('/');
  };
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tools, setTools] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const posts = await getPostsFromFirestore();
        const found = posts.find(p => p.id === id);
        setPost(found || null);
        // 道具情報の取得
        if (found && found.toolIds && found.toolIds.length > 0 && found.uid) {
          // 投稿者のuidで道具一覧を取得
          const allTools = await getToolsFromFirestore(found.uid);
          // 投稿で使われた道具のみ抽出
          setTools(allTools.filter(t => found.toolIds.includes(t.id)));
        } else {
          setTools([]);
        }
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  const displayName = useUserDisplayName(post?.uid);
  if (loading) return <div className={styles.container}>読み込み中...</div>;
  if (!post) return <div className={styles.container}>投稿が見つかりません</div>;

  // 投稿日の整形
  let dateStr = '';
  if (post.createdAt) {
    const d = typeof post.createdAt === 'string' ? new Date(post.createdAt) : post.createdAt.toDate ? post.createdAt.toDate() : post.createdAt;
    dateStr = d instanceof Date && !isNaN(d) ? d.toLocaleString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }) : '';
  }

  return (
    <div className={styles.container}>
      <button className={styles.backButton} onClick={() => navigate(-1)}>← 戻る</button>
      <h2>{post.workName || '作品名なし'}</h2>
      {displayName && (
        <div style={{color:'#1976d2', fontSize:'0.98em', margin:'2px 0 8px 0'}}>
          投稿者: {displayName}
        </div>
      )}
      {/* 投稿者本人のみ削除ボタン表示 */}
      {user && post && user.uid === post.uid && (
        <button onClick={handleDelete} style={{background:'#e53935',color:'#fff',border:'none',borderRadius:4,padding:'6px 16px',marginBottom:12,cursor:'pointer'}}>投稿を削除</button>
      )}
      {post.state && (
        <div style={{color:'#666', fontSize:'1em', margin:'4px 0 8px 0'}}>
          状態: {post.state}
        </div>
      )}
      {dateStr && <div style={{color:'#888', fontSize:'0.95em', marginBottom:8}}>投稿日: {dateStr}</div>}
      {post.images && post.images.length > 0 && (
        <div className={styles.imageArea}>
          {post.images.map((img, idx) => (
            <img key={idx} src={img} alt="投稿画像" style={{width:240,height:240,objectFit:'cover',borderRadius:12,border:'1px solid #ccc',background:'#fafafa',marginRight:8}} />
          ))}
        </div>
      )}
      {post.workDescription && <div className={styles.description}>{post.workDescription}</div>}
      {tools.length > 0 && (
        <div style={{marginTop:24}}>
          <div style={{fontWeight:'bold',marginBottom:8}}>使用した道具</div>
          <div style={{display:'flex',flexWrap:'wrap',gap:16}}>
            {tools.map(tool => (
              <div key={tool.id} style={{display:'flex',flexDirection:'column',alignItems:'center',gap:6,padding:'8px 12px',border:'1px solid #eee',borderRadius:8,minWidth:0}}>
                {tool.images && tool.images.length > 0 && (
                  <img src={tool.images[0]} alt={tool.name} style={{width:80,height:80,objectFit:'cover',borderRadius:8,border:'1px solid #ccc',background:'#fafafa'}} />
                )}
                <span style={{fontWeight:'bold',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',maxWidth:120,marginTop:4}}>{tool.name}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PostDetail;
